import { createSelector } from 'reselect'

const createSortedCardStatusesSelector = (cardStatusIdsSelector) => createSelector<any, any, any, any[]>(
  [
    cardStatusIdsSelector,
    state => state['view-board'].cardStatuses.byId,
  ],
  (
    cardStatusIds,
    cardStatusesById,
  ) =>
    cardStatusIds
      .map(id => cardStatusesById[id])
      .sort((a, b) => a.position - b.position)
)

export default createSortedCardStatusesSelector
